import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgAustraliaPost({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4 3h16a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1z" fill="#DC1928" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.605 6v.605c2.08 0 3.974 1.5 3.974 3.684 0 2.106-1.71 3.658-3.71 3.737v3.868C15.157 17.842 18 15.342 18 11.921 18 8.552 15.158 6 11.868 6h-.263zm-1.342 11.684V6.315C7.79 7.105 6 9.315 6 11.973c0 2.659 1.763 4.948 4.263 5.71z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgAustraliaPost
